<template>
  <div>
    <vx-card
      class="campaigns-table"
      :noShadow="true"
      :title="$t('')"
    >
      <template v-slot:actions>
        <div class="campaign-list-title md:flex">
          <h2 v-bind:class="{ addMargin: !showFilterCounter }" class="mt-2">Campaigns List</h2>

          <div v-if="showFilterCounter" class="flex active-filters-parent">
            <vx-tooltip class="tooltip-label" position="bottom">

              <span class="active-filter-counter">
                <span>{{ filterCounter }}</span>
                {{ filterCounterText }}
              </span>

              <template slot="html">
                <div class="tooltip-parent">
                  <h6 class="tooltip-h6">Filters</h6>

                  <div v-if="appliedFilters.search" class="flex">
                    <h6 class="tooltip-title">search:</h6>
                    <span class="campaigns-name-search tootltip-data"> {{ appliedFilters.search }}</span>
                  </div>

                  <div class="flex account-parent" v-if="(appliedFilters.accountsIds || []).length > 0">
                    <h6 v-if="appliedFilters.accountsIds" class="tooltip-title">Account:</h6>
                    <div class="account-limit">
                    <span :key="account.id" v-for="account in allAccounts">
                      <span :key="accountAgFilter" v-for="accountAgFilter in appliedFilters.accountsIds.slice(0,1)">
                      <span v-if="accountAgFilter == account.id && !(appliedFilters.accountsIds || []).includes(-1)"
                            class="tootltip-data">
                      {{ account.name }}
                      </span>
                      </span>
                    </span>
                    </div>
                    <span class="account-counter"
                          v-if="(appliedFilters.accountsIds || []).length -1 > 0 && !(appliedFilters.accountsIds || []).includes(-1)">
                    +{{ appliedFilters.accountsIds.length - 1 }}
                    </span>

                    <span class="tootltip-data" v-if="(appliedFilters.accountsIds || []).includes(-1)">All</span>
                  </div>

                  <div v-if="appliedFilters.status" class="flex">
                    <h6 class="tooltip-title">Status:</h6>
                    <span class="tootltip-data">{{ appliedFilters.status }}</span>
                  </div>

                  <div v-if="appliedFilters.type" class="flex">
                    <h6 class="tooltip-title">Type:</h6>
                    <span v-if="appliedFilters.type == 2" class="tootltip-data">Recommendations</span>
                    <span v-else-if="appliedFilters.type == 1" class="tootltip-data">Inline</span>
                    <span v-else-if="appliedFilters.type == 3" class="tootltip-data">Video</span>
                  </div>

                  <div v-if="appliedFilters.event" class="flex">
                    <h6 class="tooltip-title">Conversions:</h6>
                    <span v-if="appliedFilters.event == 'total'" class="tootltip-data">Conversions</span>
                    <span v-else-if="appliedFilters.event == 'leads'" class="tootltip-data">leads</span>
                    <span v-else-if="appliedFilters.event == 'install'" class="tootltip-data">App Installs</span>
                    <span v-else-if="appliedFilters.event == 'add_to_wishlist'"
                          class="tootltip-data">Add To Wishlist</span>
                    <span v-else-if="appliedFilters.event == 'add_to_cart'" class="tootltip-data">Add To Cart</span>
                    <span v-else-if="appliedFilters.event == 'sign_up'" class="tootltip-data">Sign Up</span>
                    <span v-else-if="appliedFilters.event == 'purchase'" class="tootltip-data">Purchase</span>
                  </div>
                </div>
              </template>
            </vx-tooltip>

            <div id="campaigns-clear-filters-button" v-on:click="clearFilters"
                 class="clear-filters-parent tooltip-label">
              <span class="clear-filters">Clear</span>
              <span>
                <vs-icon class="clear-icon" icon="speakol-cancel" icon-pack="speakol"></vs-icon>
              </span>
            </div>
          </div>

        </div>
        <!-- desktop version -->
        <div class="mt-2 md:flex buttons-parent">
          <div class="date-picker-li">
            <speakol-date-range-picker @click.native="$gtag.event('Campaigns_date_range_apply')"
                                       id="campaigns-date-range-picker-input" class="campaigns-datePicker"
                                       v-model="agFilters.dateRange" @input="applyFilters()"
                                       :placeholder="$t('Filter by date')"></speakol-date-range-picker>
          </div>

          <div class="all-filters-li float-right ml-3">
            <button id="campaigns-all-filters-button" class="shadow-none speakol-table-all-filters-button"
                    @click="showAllFilters = !showAllFilters">
              <vs-icon class="speakol-filters" icon="speakol-filters" icon-pack="speakol"></vs-icon>
              <span class="all-filters-span">
                  {{ $t('All Filters') }}
                </span>
            </button>
          </div>

          <div class="export-li-mobile-version float-right ml-3">
            <button id="campaigns-export-button" class="shadow-none speakol-table-export-button" v-bind:class="{ 'export-disabled': isExportButtonDisabled }" @click="exportButton()"
                    :disabled="isExportButtonDisabled">
              {{ $t('Export') }}
            </button>
          </div>
        </div>

        <!-- start -->
        <div v-show="showAllFilters" :key="clearTreeSelect" :class="{ bindingFiltersContainer: showFilterCounter }"
             id="filters-container" class="filters-container">
          <ul class="advertisers-table-desktop-version">
            <li class="mb-6">
              <div class="campagin-search-parent">
                <vs-icon class="campagin-search-icon speakol-search" icon-pack="speakol" round></vs-icon>
                <input @click="$gtag.event('Campaigns_campaign_name')" id="campaigns-campaign-name-input"
                       placeholder="Campaign Name" class="w-full campagin-name-input" type="text"
                       v-model="agFilters.search" />
              </div>
            </li>

            <li class="mb-6">
              <speakol-checkbox-tree
                :multipleMaxWidth="'90px'"
                id="campaigns-sub-accounts-input"
                :fetchFunction="loadSubAccounts"
                v-if="$hasAnyFeature('sub-accounts') && allAccounts.length > 1"
                :displayLabelName="'name'"
                v-model="agFilters.accountsIds"
                :includeAll="true"
                :placeholder="$t('All Sub Accounts')">
              </speakol-checkbox-tree>
            </li>
            <!-- v-if="$hasAnyFeature('sub-accounts') && allAccounts.length > 1" -->

            <li @click="$gtag.event('Status_filter')" class="mb-6">
              <treeselect id="campaigns-all-status-input" :options="options.status" v-model="agFilters.status"
                          placeholder="All Status"></treeselect>
            </li>

            <li @click="$gtag.event('Type_filter')" class="mb-6">
              <treeselect id="campaigns-all-types-input" :options="options.types" v-model="agFilters.type"
                          placeholder="All Types"></treeselect>
            </li>

            <li @click="$gtag.event('Events_filter')" class="mb-12">
              <treeselect id="campaigns-all-events-input" :options="pixelEvents" v-model="agFilters.event"
                          placeholder="Conversions"></treeselect>
            </li>


            <li class="mb-4">
              <button id="campaigns-filter-button" class="w-full shadow-none speakol-table-filter-button"
                      @click="applyFilters">
                {{ $t('Filter') }}
              </button>
            </li>

            <li class="">
              <button id="campaigns-cancel-button" class="w-full shadow-none speakol-table-cancel-button"
                      @click="closeFilters">
                {{ $t('Cancel') }}
              </button>
            </li>

          </ul>
        </div>
        <!-- start -->

        <!-- desktop version -->

        <SpeakolExport @click="$gtag.event('Campaigns_popup_export')" :fileName="'CampaignsList'"
                       :isActive="isExportPopupActive" exportType="campaigns"
                       :params="{...agFilters, ...exportSortModel}" @hide="isExportPopupActive=false"
                       :columns="visibleColumns"/>
      </template>

      <a-g-speakol-table ref="agTable" @sortChanged="sortChanged"
                         @dataChange="isExportButtonDisabled = $event.totalItems === 0" :filters="agFilters"
                         :columns="agColumns" :options="agOptions"
                          @visibleColumnsChanged="updateVisibleColumns"></a-g-speakol-table>
    </vx-card>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {mapGetters} from 'vuex'
import campaignStatus from '@/views/campaigns/campaignStatus.js'
import CampaignActionsDropdown from '@/views/campaigns/index/components/CampaignActionsDropdown.vue'
import AGSpeakolTable from '@/components/AGSpeakolTable'
import CampaignAdvertisersDataSource from '@/datasources/CampaignAdvertisersDataSource'
import CampaignStatusToggle from '@/views/campaigns/index/components/CampaignStatusToggle'
import ConversionsCol from '@/views/campaigns/index/components/ConversionsCol'
import AgGridCampaignStatus from './AgTableComponents/CampaignStatusComponent.vue'
import AgGridCampaignInsight from './AgTableComponents/CampaignInsightUrl.vue'
import accountsTree from  '@/helpers/accountsTree'
import SpeakolExport from  '@/components/SpeakolExport'
import {cloneDeep} from 'lodash'

export default {
  components: {
    SpeakolExport,
    Treeselect,
    CampaignActionsDropdown,
    AGSpeakolTable,
    CampaignStatusToggle,
    ConversionsCol,
    CampaignName: AgGridCampaignInsight,
    CampaignStatus: AgGridCampaignStatus,
    CampaignActions: {
      components: {
        CampaignActionsDropdown
      },
      template: '<CampaignActionsDropdown :campaign="params.data" />'
    }
  },
  data () {
    return {
      visibleColumns: [],
      isExportButtonDisabled: false,
      isExportPopupActive: false,
      exportSortModel: {
        sortBy: 'id',
        isASC: false
      },
      allAccounts: [],
      agFilters: {
        search: '',
        event: null,
        type: null,
        status: null,
        is_admin: 0,
        accountsIds: [],
        dateRange: {
          startDate: new Date('January 1, 2016'),
          endDate: new Date()
        }
      },
      appliedFilters: {
        search: '',
        event: null,
        type: null,
        status: null,
        is_admin: 0,
        accountsIds: [],
        dateRange: {
          startDate: new Date('January 1, 2016'),
          endDate: new Date()
        }
      },
      filteredByDefault: false,

      agOptions: {
        context:{
          parent:this
        },
        dataSource: CampaignAdvertisersDataSource
      },
      agColumns: this.getAgGridColumns(),
      options: {
        status: campaignStatus.map((status) => {
          return {
            id: status,
            label: status
          }
        }),
        types: []
      },

      showAllFilters: false,
      clearTreeSelect: Math.random(),
      campaignsHasFilters: false,
      showFilterCounter: false,
      filterCounter: 0,
      filterCounterText: 'Active Filter'
    }
  },
  async created () {
    await this.$store.dispatch('campaign/getDisplayTypes').then(() => {
      this.setFilterOptions()
    })

    await this.loadSubAccounts()
  },
  mounted () {
    window.addEventListener('click', (e) => {
      const filters_container = document.getElementById('filters-container')
      if (!filters_container) return

      const all_filters_button = document.getElementById('campaigns-all-filters-button')
      if (!all_filters_button) return

      if (!filters_container.contains(e.target) && !all_filters_button.contains(e.target)) {
        this.showAllFilters = false
      }
    })
  },
  computed: {
    ...mapGetters({
      types: 'campaign/types',
      pixelEvents: 'campaign/pixelEvents'
    }),
    pixelEvent () {
      return (!this.agFilters.event || this.agFilters.event === 'total') ? 'conversions' : this.agFilters.event
    }
  },
  methods: {
    updateVisibleColumns(visibleColumns) {
      this.visibleColumns = visibleColumns.map(col => col.colId)
     },
    exportButton () {
      this.isExportPopupActive = true
      this.$gtag.event('Export_button')
    },
    filterCount () {
      const keys = Object.keys(this.agFilters)
      this.filterCounter = 0
      keys.forEach(key => {
        let value = this.agFilters[key]
        if (key === 'dateRange') {
          return
        }
        if (Array.isArray(value)) {
          value = value.length
        }
        if (value) {
          this.filterCounter++
        }
      })

      if (this.filterCounter === 1) {
        this.filterCounterText = 'Active Filter'
      } else if (this.filterCounter > 1) {
        this.filterCounterText = 'Active Filters'
      } else {
        this.showFilterCounter = false
      }

      return this.filterCounter
    },
    activeFilters () {
      return (
        this.agFilters.search ||
        this.agFilters.status ||
        this.agFilters.type ||
        this.agFilters.event ||
        (this.$hasAnyFeature('sub-accounts') && this.agFilters.accountsIds.length)
      )
    },
    clearFilters () {
      this.agFilters.search = ''
      this.agFilters.event = null
      this.agFilters.type = null
      this.agFilters.status = null
      if (this.$hasAnyFeature('sub-accounts')) {
        // this.allAccounts = []
        this.agFilters.accountsIds = []
        // to clear vue tree select selected value
        this.clearTreeSelect = Math.random()
      }
      this.applyFilters()
      this.showFilterCounter = false
    },
    closeFilters () {
      this.showAllFilters = false
    },
    async loadSubAccounts () {
      this.allAccounts = await accountsTree.loadSubAccounts()

      return accountsTree.maptToTree(this.allAccounts)
    },
    sortChanged (sortModel) {
      const sortColumn = sortModel[0] || {}

      this.exportSortModel = {
        sortBy: sortColumn.colId,
        isASC: sortColumn.sort === 'asc'
      }
    },
    getAgGridColumns () {
      const self = this

      const advertisingChannelColumns = [
        {
          headerName: 'Advertising Channel',
          field: 'advertising_channel',
          minWidth: 210,
          valueGetter (params) {
            if (params.data) {
              return params.data.advertising_channel_title ? params.data.advertising_channel_title : 'N/A'
            }
          }
        }
      ]

      return [
        {
          headerName: '',
          field: 'change-status',
          cellRendererFramework: 'CampaignStatusToggle',
          minWidth: 80,
          maxWidth: 80,
          pinned: true,
          resizable: false
        },
        {
          headerName: 'Campaign Name',
          field: 'name',
          cellRendererFramework: 'CampaignName',
          minWidth: 360,
          pinned: true,
          autoHeight: true,
          sortable: true
        },
        {
          headerName: 'Account Name',
          field: 'account_name',
          minWidth: 230,
          valueGetter (params) {
            if (params.data && params.data.analytics) {
              return params.data.account_name ? params.data.account_name : 'N/A'
            }
          }
        },
        {
          headerName: 'Status',
          field: 'aggregated_status',
          cellRendererFramework: 'CampaignStatus',
          autoHeight: true,
          minWidth: 140,
          sortable: true
        },
        ...(this.$hasFeature(this.$constants.FEATURE_SHORTNAME.FACEBOOK_ADVERTISING_CHANNEL) ? advertisingChannelColumns : []),
        {
          headerName: 'Type',
          field: 'display_type',
          minWidth: 180,
          sortable: true,
          valueGetter (params) {
            if (params.data && params.data.analytics) {
              return params.data.display_type_name ? params.data.display_type_name : 'N/A'
            }
          }
        },
        {
          headerName: 'Impressions',
          field: 'impressions',
          minWidth: 162,
          sortable: true,
          valueGetter (params) {
            if (params.node.rowPinned) {
              return self.$options.filters.addComma(params.data.impressions)
            }

            if (params.data && params.data.analytics) {
              return self.$options.filters.addComma(params.data.analytics.impressions)
            }
          }
        },
        {
          headerName: 'Clicks',
          field: 'clicks',
          minWidth: 110,
          sortable: true,
          valueGetter (params) {
            if (params.node.rowPinned) {
              return self.$options.filters.addComma(params.data.clicks)
            }
            if (params.data && params.data.analytics) {
              return self.$options.filters.addComma(params.data.analytics.clicks)
            }
          }
        },
        {
          headerName: 'CTR',
          field: 'ctr',
          minWidth: 95,
          sign: '%',
          sortable: true,
          valueGetter (params) {
            if (params.node.rowPinned) {
              return self.$options.filters.addComma(parseFloat(params.data.ctr).toFixed(2), '%')
            }
            if (params.data && params.data.analytics) {
              return self.$options.filters.addComma(parseFloat(params.data.analytics.ctr).toFixed(2), '%')
            }
          }
        },
        {
          headerName: 'Avg. CPC',
          field: 'average_cpc',
          minWidth: 135,
          sortable: true,
          sign: '$',
          valueGetter (params) {
            if (params.node.rowPinned) {
              return self.$options.filters.addComma(parseFloat(params.data.average_cpc).toFixed(2), '$')
            }
            if (params.data && params.data.analytics) {
              return self.$options.filters.addComma(parseFloat(params.data.analytics.average_cpc).toFixed(2), '$')
            }
          }
        },
        {
          headerName: 'Video Views',
          field: 'video_views',
          minWidth: 170,
          sortable: true,
          valueGetter (params) {
            if (params.node.rowPinned) {
              return self.$options.filters.addComma(params.data.video_views)
            }
            if (params.data && params.data.analytics) {
              return self.$options.filters.addComma(params.data.analytics.video_views)
            }
          }
        },
        {
          headerName: self.$t(self.pixelEvent || 'conversions'),
          field: 'filter_event',
          colId: 'filter_event',
          sortable: true,
          minWidth: 200,
          cellRendererFramework: 'ConversionsCol'
        },
        {
          headerName: 'CPA',
          field: 'filter_cpa',
          sortable: true,
          minWidth: 110,
          sign: '$',
          valueGetter (params) {
            if (params.node.rowPinned) {
              return self.$options.filters.addComma(params.data.filter_cpa, '$')
            }
            if (params.data && params.data.analytics) {
              return self.$options.filters.addComma(params.data.filter_cpa, '$')
            }
          }
        },
        {
          headerName: 'Spent',
          field: 'spent',
          minWidth: 140,
          sortable: true,
          sign: '$',
          valueGetter (params) {
            if (params.node.rowPinned) {
              return `${self.$options.filters.addComma(parseFloat(params.data.spent).toFixed(2), '$')}`
            }
            if (params.data && params.data.analytics) {
              return `${self.$options.filters.addComma(parseFloat(params.data.analytics.spent).toFixed(2), '$')}`
            }
          }
        },
        {
          headerName: 'Actions',
          field: 'actions',
          minWidth: 100,
          resizable: false,
          cellRendererFramework: 'CampaignActions'
        }
      ]
    },
    applyFilters () {
      if (!this.$refs['agTable']) return

      this.agColumns = this.getAgGridColumns()
      this.$refs['agTable'].setColumnDefs([])
      this.$refs['agTable'].setColumnDefs(this.agColumns)

      this.agFilters.dateRange = this.formatFilterationDate(this.agFilters.dateRange)

      this.$refs['agTable'].applyFilters()
      this.showAllFilters = false
      this.showFilterCounter = true
      this.appliedFilters = cloneDeep(this.agFilters)
      this.filteredByDefault = !!this.agFilters.event
      this.$gtag.event('Campaigns_filter')
      this.filterCount()
    },
    formatFilterationDate (dateRange) {
      return {
        startDate: this.$moment(dateRange.startDate).format('YYYY-MM-DD'),
        endDate: this.$moment(dateRange.endDate).format('YYYY-MM-DD')
      }
    },
    setFilterOptions () {
      this.options.types = this.types.map((item) => {
        return {
          id: item.id,
          label: item.title
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .ag-cell-wrapper {
  width: 100% !important;
}
/deep/ .total {
  font-weight: 500 !important;
  font-size: 14px !important;
}
.filters-container {
  background-color: white;
  border: 1px solid #dedede;
  border-radius: 5px;
  width: 360px;
  position: absolute;
  right: 165px;
  top: 76px;
  z-index: 1;
  padding: 29px;
}

.campaign-list-title {
  position: absolute;
  left: 20px;
  top: 25px;
}

.active-filter-counter {
  color: rgba(44, 44, 44, 0.56);
}

.speakol-table-export-button {
  background-color: #0092d7;
  color: white;
  border-radius: 3px;
  padding: 7px 20px;
  border: 1px solid #0092d7;
  width: 135px;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
}

.tooltip-label {
  margin-top: 12px;
}

.tooltip-parent {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.speakol-table-all-filters-button {
  background-color: white;
  color: #0092d7;
  border: 1px solid #0092d7;
  border-radius: 3px;
  padding: 7px 0 7px 25px;
  width: 135px;
  cursor: pointer;
  height: 40px;
  position: relative;
  font-size: 14px;
}

.speakol-filters {
  color: #0092d7 !important;
  position: absolute;
  margin-left: -30px;
  margin-top: -2px;
  font-size: 20px !important;
}

.date-picker-li {
  .vue-daterange-picker {
    padding-bottom: 9px !important;
  }
}

.speakol-table-filter-button {
  background-color: #0092d7;
  color: white;
  border-radius: 3px;
  padding: 7px 20px;
  border: 1px solid #0092d7;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
}

.speakol-table-cancel-button {
  background-color: white;
  color: #2c2c2c;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 7px 20px;
  width: 135px;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
}

.account-counter {
  color: white;
  font-size: 14px;
  margin-left: 0;
  font-weight: 500;
}

.vx-card__title,
.vx-card__actions {
  width: 100%;
}

.campaign-title-link {
  text-decoration: underline;
  color: #626262 !important;
}

.campaigns-datePicker {
  .reportrange-text {
    border: 1px solid #cfcfcf;
  }
}

.vs-con-input {
  width: 168px;
  height: 40px;
  float: right;
}

.vs-input--input {
  border: 1px solid #cfcfcf !important;
}

.vs-input--input:focus {
  box-shadow: none !important;
}

.vs-icon {
  color: #cfcfcf;
}

.advertisers-table-mobile-version {
  display: none;
}

.clear-filters-parent {
  cursor: pointer;

  .clear-filters {
    color: #0092d7;
    font-weight: 600;
    font-size: 14px;
    margin-left: 8px;
  }

  .clear-icon {
    color: #0092d7;
    margin-left: 8px;
    font-size: 13px !important;
    position: relative;
    top: 1px;
  }
}

.active-filters-parent {
  margin-left: 20px;
}

/deep/ .speakol-date-range-picker {
  width: 260px !important;
}

.tooltip-h6 {
  color: white;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  margin-top: 10px;
}

.tooltip-title {
  color: white;
  font-weight: 200;
  line-height: 21px;
}

.tootltip-data {
  font-weight: 500;
  font-size: 14px;
  margin-left: 5px;
}

.campaigns-name-search {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sub-account-name {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sub-account-parent {
  display: -webkit-box;
}

.account-limit {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 115px;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .all-filters-li,
  .speakol-table-all-filters-button,
  .export-li-mobile-version,
  .speakol-table-export-button,
  .date-picker-li,
  .speakol-date-range-picker {
    width: 100% !important;
  }

  /deep/ .vx-card__actions {
    width: 100% !important;
  }

  .active-filters-parent {
    margin-left: 0;
  }

  .speakol-table-all-filters-button {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .campaign-list-title {
    position: inherit;
  }

  .filters-container {
    right: 21px;
    width: 299px;
    top: 193px;
  }

  .bindingFiltersContainer {
    top: 235px;
  }

  .advertisers-table-mobile-version {
    display: block;
  }

  .vs-con-input {
    width: 100%;
    float: none !important;
  }

  .vs-con-input-label {
    width: 100%;
  }

  .vue-treeselect__x-container:hover {
    color: #616161;
  }

  .vue-treeselect__x {
    height: 10px !important;
  }

  .date-picker-li {
    .vue-daterange-picker {
      padding-bottom: 0 !important;
    }
  }

  .tooltip-label {
    margin-top: 20px;
    margin-bottom: 18px !important;
  }

  .addMargin {
    margin-bottom: 30px !important;
  }
}

@media (max-width: 576px) {
  .whitespace-no-wrap {
    color: #cfcfcf;
    margin-right: 10px;
  }

  .reportrange-text {
    border: 1px solid #cfcfcf;
  }
}

@media (max-width: 414px) {
  .filters-container {
    width: calc(100% - 42px);
  }
}

@media (max-width: 375px) {
  .filters-container {
    width: 300px;
  }
}

@media (max-width: 320px) {
  .filters-container {
    width: 245px;
  }
}

.campagin-name {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 150px;
  white-space: nowrap;
}

.first-line-filters {
  width: 260px !important;
}

/deep/ .vue-treeselect--searchable:not(.vue-treeselect--disabled) .vue-treeselect__value-container {
  height: 38px !important;
  position: relative;
  top: 2px;
  border-radius: 3px;
}

.reportrange-text {
  width: 180px !important;
}

.sub-accounts-filter {
  width: 260px !important;
}

/deep/ .vs-con-input {
  width: 260px;
  position: relative;
  top: 0;
}

.campagin-search-icon {
  position: absolute;
  z-index: 9;
  top: 8px;
  left: 10px;
}

.campagin-search-parent {
  position: relative;
}

.campagin-name-input {
  width: 260px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #ddd;
  text-indent: 35px;
}

.campaigns-table {
  ::placeholder {
    color: #cfcfcf;
    font-weight: 500;
    font-size: 14px;
  }
}

/deep/ .vue-treeselect__value-remove {
  svg {
    width: 7px !important;
  }
}

/deep/ .vue-treeselect__multi-value-label {
  font-size: 11px !important;
}

.export-disabled {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}
</style>
